
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-9405467e!sass-loader?sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Dashboard.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Dashboard.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-9405467e!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Dashboard.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/domains/dashboard/Dashboard.vue
// module id = 477
// module chunks = 2